// extracted by mini-css-extract-plugin
module.exports = {"MOBILENAV_MAX":"666px","PHONE_MAX":"666px","TABLET_MIN":"667px","TABLET_MAX":"1150px","FULL_MIN":"1151px"};